import angular from 'angular'

import { RepositoryService } from './services/repository.service'

import { RepositoryController } from './repository.controller'
import { AllController } from './pages/all/all.controller'
import { RecentsController } from './pages/recents/recents.controller'
import { UsedInController } from './pages/used-in/used-in.controller'

import { repositoryGeneralScreen } from './directives/repository-general-screen/repository-general-screen.directive'
import { repositoryScreenSections } from './directives/repository-screen-sections/repository-screen-sections.directive'
import { attachInsideTheModuleModal } from './directives/attach-inside-the-module-modal/attach-inside-the-module-modal.directive'
import { all } from './directives/all/all.directive'
import { recents } from './directives/recents/recents.directive'
import { organized } from './directives/organized/organized.directive'
import { assetCard } from './directives/asset-card/asset-card.directive'
import { assetFolder } from './directives/asset-folder/asset-folder.directive'
import { floatingToolBar } from './directives/floating-tool-bar/floating-tool-bar.directive'
import { manageAssetsTabGeneral } from './directives/manage-assets-tab-general/manage-assets-tab-general.directive'
import { manageAssetsTabAccess } from './directives/manage-assets-tab-access/manage-assets-tab-access.directive'
import { manageFoldersTabAccess } from './directives/manage-folders-tab-access/manage-folders-tab-access.directive'
import { manageCustomFields } from './directives/manage-custom-fields/manage-custom-fields.directive'
import { repositoryDragAndDrop } from './directives/repository-drag-and-drop/repository-drag-and-drop.directive'
import { uploadTab } from './directives/upload-tab/upload-tab.directive'

import { moveToTrashDialog } from './dialogs/move-to-trash/move-to-trash-dialog.directive'
import { organizeAssetDialog } from './dialogs/organize-asset/organize-asset-dialog.directive'
import { manageAssetsDialog } from './dialogs/manage-assets/manage-assets-dialog.directive'
import { confirmRestoreAssetVersionDialog } from './dialogs/confirm-restore-asset-version/confirm-restore-asset-version-dialog.directive'
import { createFolderDialog } from './dialogs/create-folder/create-folder-dialog.directive'
import { sharedPacks } from './directives/shared-packs/shared-packs.directive'
import { sharedPacksItems } from './directives/shared-packs-items/shared-packs-items.directive'
import { chooseDocTemplateDialog } from './dialogs/choose-doc-template/choose-doc-template-dialog.directive'
import { chooseDocFormatToDownloadDialog } from './dialogs/choose-doc-format-to-download/choose-doc-format-to-download-dialog.directive'

const module = angular
  .module('deskfy.repository', [])
  .factory('RepositoryService', RepositoryService)
  .controller('RepositoryController', RepositoryController)
  .controller('RecentsController', RecentsController)
  .controller('AllController', AllController)
  .controller('UsedInController', UsedInController)
  .directive('repositoryGeneralScreen', repositoryGeneralScreen)
  .directive('repositoryScreenSections', repositoryScreenSections)
  .directive('attachInsideTheModuleModal', attachInsideTheModuleModal)
  .directive('all', all)
  .directive('recents', recents)
  .directive('organized', organized)
  .directive('sharedPacks', sharedPacks)
  .directive('sharedPacksItems', sharedPacksItems)
  .directive('assetCard', assetCard)
  .directive('assetFolder', assetFolder)
  .directive('floatingToolBar', floatingToolBar)
  .directive('manageAssetsTabGeneral', manageAssetsTabGeneral)
  .directive('manageAssetsTabAccess', manageAssetsTabAccess)
  .directive('manageFoldersTabAccess', manageFoldersTabAccess)
  .directive('manageCustomFields', manageCustomFields)
  .directive('repositoryDragAndDrop', repositoryDragAndDrop)
  .directive('uploadTab', uploadTab)
  .directive('moveToTrashDialog', moveToTrashDialog)
  .directive('organizeAssetDialog', organizeAssetDialog)
  .directive('manageAssetsDialog', manageAssetsDialog)
  .directive('confirmRestoreAssetVersionDialog', confirmRestoreAssetVersionDialog)
  .directive('createFolderDialog', createFolderDialog)
  .directive('chooseDocTemplateDialog', chooseDocTemplateDialog)
  .directive('chooseDocFormatToDownloadDialog', chooseDocFormatToDownloadDialog)

export const repositoryModule = module
